/** Copy for row menus while an async action is in flight (friend invite, kick, etc.). */
export const GROUP_ROW_MENU_REASONS = {
  FRIEND_REQUEST_SENDING: 'Sending request…',
  MEMBER_REMOVAL_SENDING: 'Removing…',
} as const;

export const FRIEND_INVITE_REASONS = {
  REQUEST_SENDING: GROUP_ROW_MENU_REASONS.FRIEND_REQUEST_SENDING,
} as const;
